//Imports
import './navbar.style.css';
import vecLogo from '../../Assets/logovec.webp';
import handleLinkClick from '../ScrollTo';

const Navbar: React.FC = () => {

    interface LinkProps {
        text: string;
        link: string;
        tabidx: number;
    }
    
    const RenderLink = ({ text, link, tabidx }: LinkProps): JSX.Element => {
        return (
            <li className='itens-navbar' key={text} tabIndex={tabidx}>
                <a href={link} onClick={handleLinkClick}>
                    {text}
                </a>
            </li>
        );
    };

    const links: LinkProps[] = [
        { text: 'Sobre Nós', link: '#about', tabidx: 1 },
        { text: 'Soluções', link: '#CoursesAndSolutions' , tabidx: 2 },
        { text: 'Feedbacks', link: '#feedbacks', tabidx: 3 },
        { text: 'Contato', link: '#contact', tabidx: 4 },

        // ... outros links
    ];

    const toggleMenu = () => {
        let menu = document.querySelector('nav#navbar');
        menu?.classList.toggle('navbar-active');
    }
    
    return(
        <nav id="navbar">
            <div>
                <div className='img-box-navbar'>
                    <img src={vecLogo} alt="Logomarca V&C" />
                </div>
                <button id='btn-menu' onClick={toggleMenu}>
                    <span className="line line1"></span>
				    <span className="line line2"></span>
				    <span className="line line3"></span>
                </button>
                <ul className='menu-itens-navbar'> 
                    {links.map((linkProps) => (
                        <RenderLink
                            text={linkProps.text}
                            link={linkProps.link}
                            tabidx={linkProps.tabidx}
                        />
                    ))}
                </ul>       
            </div>
        </nav>
    )
}

export default Navbar;